module.exports = __webpack_public_path__ + "img/neighbor-0-bg.4cbd338d.jpg";